module.exports = __webpack_public_path__ + "static/img/pm.2fc112e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/pm.png
// module id = YKbL
// module chunks = 18